<app-dashboard-filters class="dashboard-actions-select"> </app-dashboard-filters>

<ng-container *ngIf="(isLoading$ | async) === false; else loading">
  <ng-container *ngIf="(isNewZenityAccount$ | async) === false">
    <div class="dashboard-container">
      <ng-content></ng-content>
    </div>
  </ng-container>
</ng-container>

<ng-template #loading>
  <div class="spinner">
    <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
  </div>
</ng-template>

<app-dashboard-new-org *ngIf="(isNewZenityAccount$ | async) === true"></app-dashboard-new-org>
